import moment from 'moment';

export const tableList = {
    filterQuery: '',
    sort: '',
    direction: '',
    perPage: 10,
    currentPage: 1,
    showFilter: false,
    rows: null,
    fieldTable(key, label, sortable = true, fieldClass = '') {
        return {key, label, sortable, class: fieldClass};
    },
    filterMoment(date) {
        return moment.utc(date).format('YYYY-MM-DD');
    },
    formatedDate(date){
        let arrayDate = date.split('-');
        return arrayDate[2] + '/' + arrayDate[1] + '/' + arrayDate[0]
    },
    dateDiff(date) {
        const timeDiff =
            new Date(moment(new Date(date)).format('D MMM YYYY')).getTime() -
            new Date(moment(new Date()).format('D MMM YYYY')).getTime();
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }
};
